/**
 * DECISIONS 406 (the owner: "APCs and M113s should carry some bandages and basic restock for small arms, so bots can re-arm
 * remotely"), with GameConfig.finiteSupply: an APC's or M113's load (`supply.carrier`) — bandages, bullet magazines and its
 * explosive small arms by kind. It serves as a crate does (core/supply.ts crateStocked, core/grenadeStock.ts standingCrate):
 * a person beside it bandages and re-arms from it, the bots walk to it as to a crate, the nearest of the three. Its bullets
 * and bandages are handed out as a crate's; its explosives here, from its own load rather than the side's ledgers (a crate's
 * come from those). Loaded and refilled at its base out of the side's stock (core/supplyStock.ts loadCarriers).
 * Kept free of the stocks' modules, which read it.
 */
import type { CarrierExplosives, StructureState } from '../types';

/** A standing carrier's load. */
export function carrierLoad(s: Pick<StructureState, 'health' | 'supply'>): boolean {
  return s.health > 0 && s.supply?.carrier === true;
}

/** What of an explosive kind a crate holds of its own: a carrier's load (0 when out); null for a crate, which hands out its side's ledger. */
export function carrierHas(s: Pick<StructureState, 'supply'>, kind: keyof CarrierExplosives): number | null {
  return s.supply?.carrier ? s.supply.explosives?.[kind] ?? 0 : null;
}

/** `n` of an explosive kind taken out of carrier `id`'s load. */
export function takeFromCarrier(structures: StructureState[], id: number, kind: keyof CarrierExplosives, n: number): StructureState[] {
  if (n <= 0) return structures;
  return structures.map(s => (s.id === id && s.supply?.explosives ? { ...s, supply: { ...s.supply, explosives: { ...s.supply.explosives, [kind]: s.supply.explosives[kind] - n } } } : s));
}
